export const BILLABLE_ACTIONS_USED_EVENT = "billableActionsUsed";

export function formatBillableActionCount(value) {
  const number = Number(value);
  if (!Number.isFinite(number)) return "0";
  if (number >= 10000) {
    const thousands = number / 1000;
    if (Number.isInteger(thousands)) return `${thousands}k`;
    return `${thousands.toFixed(1).replace(/\.0$/, "")}k`;
  }
  return number.toLocaleString();
}

export function billableActionsManageHref(accountId, websiteId) {
  if (accountId && websiteId) {
    return `/accounts/${accountId}/subscriptions?website_id=${websiteId}`;
  }
  if (accountId) {
    return `/accounts/${accountId}/subscriptions`;
  }
  return null;
}

function billableActionsMeterPeriodSuffix() {
  const planType =
    typeof document !== "undefined"
      ? document.getElementById("upgrade")?.getAttribute("data-plan-type")
      : null;
  // Free plans use a lifetime AI allotment; paid plans reset monthly.
  if (String(planType || "") === "free") return "";
  return " this month";
}

function billableActionsMeterNoun() {
  const planType =
    typeof document !== "undefined"
      ? document.getElementById("upgrade")?.getAttribute("data-plan-type")
      : null;
  // Free plans meter only lifetime AI actions; paid meters all billable actions.
  if (String(planType || "") === "free") return "AI actions";
  return "actions";
}

export function formatBillableActionMeterLabel(usage, limit) {
  return `${formatBillableActionCount(usage)} of ${formatBillableActionCount(
    limit
  )} ${billableActionsMeterNoun()} used${billableActionsMeterPeriodSuffix()}`;
}

// Same copy as formatBillableActionMeterLabel, but with the period suffix wrapped
// in its own element so a container query can drop it when the footer is skinny
// (e.g. the embedded chat in a narrow column). Inputs are numeric-only, so the
// interpolation is safe to assign via innerHTML.
export function formatBillableActionMeterLabelHtml(usage, limit) {
  const period = billableActionsMeterPeriodSuffix();
  const periodHtml = period
    ? `<span class="billable-actions-meter-period">${period}</span>`
    : "";
  return `${formatBillableActionCount(usage)} of ${formatBillableActionCount(
    limit
  )} ${billableActionsMeterNoun()} used${periodHtml}`;
}

export function dispatchBillableActionsUsed(count = 1) {
  const parsed = Number(count);
  const resolved = Number.isFinite(parsed) ? parsed : 1;
  // nothing was billed (admins / exempt runs) — leave the meter untouched
  if (resolved <= 0) return;

  document.dispatchEvent(
    new CustomEvent(BILLABLE_ACTIONS_USED_EVENT, {
      detail: { count: resolved },
    })
  );
}

// Tier weights for label copy shown BEFORE a turn runs (e.g. "Uses up to N
// actions"). The authoritative charge is always the server-returned
// billable_actions; these mirror app/services/ai/billable_actions.rb.
export const LOW_EFFORT_IMPORT_ACTIONS = 10;
export const HIGH_EFFORT_IMPORT_ACTIONS = 100;

// The count actually billed for a turn, as reported by the server. The client
// never estimates this itself — it increments the meter by exactly what was
// charged. Falls back to 1 only if an older payload omits the field.
export function billableActionsFromResponse(data) {
  const raw = data && data.billable_actions;
  const count = Number(raw);
  return raw != null && Number.isFinite(count) ? count : 1;
}
